import axios from "axios";
import { postUrl } from "./V3Api";
import { store } from "../NextApp";
import { userSignInSuccess, userSignOutSuccess } from "../appRedux/actions";
import { wait } from "./Tools";
let isRefreshing=false;
export function baseRequestApi() {
  //return `https://localhost:7096/`;
 // return `https://api.agahinaslefarda.ir/`;
  return 'https://api.agahinaslefarda.ir/api/';
 //return 'https://localhost:44380/api/';
 //return 'http://localhost:5055/api/';
 //return 'http://localhost:5000/api/';
}
export async function postData(token, url, data) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  if (token) {
    axios.defaults.headers.common = { Authorization: `bearer ${token}` };
  }

  let baseApi = baseRequestApi();
  var baseUrl = `${baseApi.concat(url)}`;

  let result = await axios.post(baseUrl, data, config).catch((err) => {
    return handleError(err);
  });
  
  return result;
}
export async function putData(token, url, data) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  

  let baseApi = baseRequestApi();
  var baseUrl = `${baseApi.concat(url)}`;

  let result = await axios.put(baseUrl, data, config).catch((err) => {
    return handleError(err);
  });
  
  return result;
}
export async function deleteData(token, url, data) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  

  let baseApi = baseRequestApi();
  var baseUrl = `${baseApi.concat(url)}`;

  let result = await axios.delete(baseUrl, data, config).catch((err) => {
    return handleError(err);
  });
  
  return result;
}
export async function postUploadData(token, url, data) {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      withCredentials: true,
      "Access-Control-Allow-Origin": "*",
    },
  };
  if (token) {
    axios.defaults.headers.common = { Authorization: `bearer ${token}` };
  }
  let baseApi = baseRequestApi();
  var baseUrl = `${baseApi.concat(url)}`;
  let result = await axios.post(baseUrl, data.file, config).catch((err) => {
    return handleError(err);
  });
  
  return result;
}

export async function getData(token, url, data) {
  let baseApi = baseRequestApi();
  var baseUrl = `${baseApi.concat(url)}`;
  var config = {
    "Access-Control-Allow-Origin": "*",
  };
  if (token) {
    axios.defaults.headers.common = { Authorization: `bearer ${token}` };
  }
  
  let result = axios
    .get(baseUrl, {
      params: data,
      headers: config,
    })
    .catch((err) => {
      
      //console.warn();
      return handleError(err);
    });
   
  return result;
}
export async function GetBlobAsync(token, url, data) {
  let baseApi = baseRequestApi();
  var baseUrl = `${baseApi.concat(url)}`;
  var config = {
    "Access-Control-Allow-Origin": "*",
  };
  if (token) {
    axios.defaults.headers.common = { Authorization: `bearer ${token}` };
  }
  let result = axios({
    url: baseUrl,
    params: data,
    headers: config,
    method: "GET",
    responseType: "blob",
  }).catch((err) => {
    return handleError(err);
  });
  return result;
}
export async function getUploadData(url, data, config) {
  let baseApi = baseRequestApi();
  var baseUrl = `${baseApi.concat(url)}`;
  let result = axios.get(baseUrl, {
    params: data,
    headers: config,
  });
  return result;
}
function handleError(err,req) {
  console.warn(err.response);
  var code = err?.response?.status;
  if (code === 401) {
   return refreshAccessTokenAndRetry(err.response)
    
  } else if (code === 500 ) {
    var msg =
    
    err?.response?.data?.errors[0]?.message ?? "در انجام عملیات خطایی به وجود آمد";
    return {
      errorMessage: msg,
    };
  } else if ( code === 400) {
    
    var msg =
      err?.response?.data?.errors[0]?.message ?? "مقادیر به درستی وارد نشده است";
     
      return {
      errorMessage: msg,
    };
  } else {
    var msg=  err?.response?.data?.errors?.[0]?.message ?? "!در انجام عملیات خطایی به وجود آمد";
    return { errorMessage: msg };
  }
}

async function refreshAccessTokenAndRetry(conf) {
  if(isRefreshing){
    while (isRefreshing){
     await wait(1000)
    }
    conf.config.headers.Authorization='bearer '+store.getState().auth.token ;
    //return await axios(conf.config).catch((e)=>{return handleError(e)});
    return await axios(conf.config).catch((e)=>{return { errorMessage:'خطا در عملیات' }});

}
  isRefreshing=true;
  console.log("refreshing token....")
  
 const accessToken=localStorage.getItem("token");
 const refreshToken=localStorage.getItem("reToken");

  try {
      let data = await postUrl('login/refresh-token', { accessToken: accessToken, refreshToken: refreshToken })
      localStorage.setItem("token", data.data);
      store.dispatch(userSignInSuccess({at:data.data,rt:refreshToken}))
      console.log('token refreshed')
      isRefreshing=false;
      //useLoginStore.getState().update({ accessToken: data.data, refreshToken: refreshToken, isCompleteRegister: true });
     console.log(store.getState())
     conf.config.headers.Authorization='bearer '+data.data;
     //return await axios(conf.config).catch((e)=>{return handleError(e)});
     return await axios(conf.config).catch((e)=>{ return { errorMessage:'! خطا در عملیات' }});
     // return sendRequestFromObj(request);
  } catch (e) {
      isRefreshing=false;
      console.log('refresh failed')
      console.log(e);
      localStorage.removeItem("user_id");
      localStorage.removeItem("token");
      localStorage.removeItem("reToken");
      store.dispatch(userSignOutSuccess());
      // localStorage.removeItem("user_id");
     // localStorage.removeItem("token");
     // localStorage.removeItem("reToken");
      //useLoginStore.getState().update(null);
  }
  
}